import { onMounted, nextTick } from "vue";
import { WOW } from 'wowjs';
import "animate.css";
export default {
  name: "DevelopmentHistory",
  setup: function setup() {
    onMounted(function () {
      nextTick(function () {
        // 初始化WOW动画
        new WOW().init();
      });
    }); // 根据数据值返回对应的进度条颜色

    var getProgressColor = function getProgressColor(value) {
      if (value <= 10) return '#D0021B'; // 红色 - 落后国家水平

      if (value <= 15) return '#F5A623'; // 橙色 - 中等偏低

      if (value <= 25) return '#5A9BD5'; // 蓝色 - 临床需求区间

      return '#7ED321'; // 绿色 - 发达国家水平
    };

    return {
      getProgressColor: getProgressColor
    };
  }
};